import { useTranslation } from 'react-i18next';
import { buildPrice } from '@pages/checkout/helper';
import {
  OrderPriceType,
  PreviewDeliveryOption,
} from '@global/utils/orderUtils';
import './style.scss';
import { subscriptionFrequencySelector } from '@src/global/store/slices/cart/selectors';
import { useAppSelector } from '@src/global/store/hooks';

interface OrderPriceProps {
  orderPrice?: OrderPriceType;
  deliveryOption?: PreviewDeliveryOption;
  isSubscription?: boolean;
  isFreeTrial?: boolean;
}

export const OrderPrice = ({
  orderPrice,
  deliveryOption,
  isSubscription,
  isFreeTrial,
}: OrderPriceProps) => {
  const { t } = useTranslation();
  const subscriptionFrequency = useAppSelector(subscriptionFrequencySelector);
  const frequency =
    t(`subscription.${subscriptionFrequency}.capitalizedFrequency`) || '';

  if (!orderPrice) return null;
  return (
    <div className="border-bottom">
      <div className="order-price__wrap border-bottom">
        {isFreeTrial ? (
          <div className="order-price__row">
            <div>{t('checkout.review.freeTrial')}</div>
          </div>
        ) : null}

        {orderPrice.discount.value ? (
          <div className="order-price__row">
            <div>{t('checkout.review.yourSavings')}</div>
            <div>{buildPrice(orderPrice.discount, true)}</div>
          </div>
        ) : null}

        {deliveryOption ? (
          <div className="order-price__row">
            <div>{deliveryOption.title}</div>
            <div>{deliveryOption.price}</div>
          </div>
        ) : null}

        {/* TAXES */}
        <div className="order-price__row">
          <div>{t('checkout.review.taxes')}</div>
          <div>{buildPrice(orderPrice.tax)}</div>
        </div>

        {/* estimatedBill */}
        {isSubscription ? (
          <div className="order-price__row">
            <div>{t('checkout.review.estimatedBill', { frequency })}</div>
            <div>{buildPrice(orderPrice.total)}</div>
          </div>
        ) : null}
      </div>

      {/* TOTAL */}
      <div className="order-price__row order-price__row__total">
        <div>{t('checkout.review.total')}</div>
        <div>{buildPrice(orderPrice.total)}</div>
      </div>
    </div>
  );
};
